/* eslint-disable @typescript-eslint/no-explicit-any */
import { CloseSquareFilled } from '@ant-design/icons';
import { Row, Col, Form, Input, Space, AutoComplete, Select } from 'antd';
import RoleBasedAuth from 'apis/RoleBasedAPI';
import { AddFillIcon, Remove, XFillIcon } from 'assets/svg';
import Button from 'components/Button';
import { useUser } from 'contexts/User';
import { IUser } from 'interface/user.interface';
import { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import handleError401 from 'utils/handleError401';

interface IProps {
  // id: string;
  form: any;
}

export default function CreateBrandDetail(props: IProps): JSX.Element {
  const { form } = props;
  const { user } = useUser(); // lấy thông tin User đăng nhập để so sánh email vs user được chọn trong ô email
  const [users, setUsers] = useState<IUser[]>([]);

  const { mutate: getUser } = useMutation(RoleBasedAuth.getUsers, {
    onSuccess: (response) => {
      const filteredFields = form.getFieldValue('emails');

      const resultArray = response.data.filter(
        (item) =>
          !filteredFields.some(
            (value: any) => value === item.id + ' - ' + item.email
          )
      );

      setUsers(resultArray);
    },
    onError: (error) => {
      console.log(error);
    },
  });
  return (
    <>
      <Form.List name={'emails'} initialValue={[undefined]}>
        {(fields, { add, remove }, { errors }) => (
          <>
            {fields.map((field, index) => {
              return (
                <Form.Item
                  label={'Email người quản lý'}
                  required={false}
                  key={field.key}
                  style={{ marginBottom: '0px' }}
                >
                  <Row gutter={[8, 8]}>
                    <Col span={12}>
                      <Form.Item
                        {...field}
                        //  name={field.name}
                      >
                        <Select
                          placeholder="Nhập email"
                          showSearch
                          options={
                            users == null || users == undefined
                              ? []
                              : users.map((item: any) => ({
                                  label: item.fullName + ' - ' + item.jobTitle,
                                  value: item.id + ' - ' + item.email,
                                }))
                          }
                          onSearch={(value) => {
                            getUser({ email: value });
                          }}
                          onBlur={(value) => {
                            setUsers([]);
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col style={{ marginLeft: '8px', marginTop: '2px' }}>
                      {index == 0 ? (
                        <Button
                          bgColor={'bg-white'}
                          border={'border-neutral-90'}
                          customClass={'no-show'}
                          onClick={add}
                        >
                          <AddFillIcon />
                        </Button>
                      ) : (
                        <Button
                          bgColor={'bg-white'}
                          border={'border-neutral-90'}
                          customClass={'no-show'}
                          onClick={() => remove(field.name)}
                        >
                          <Remove />
                        </Button>
                      )}
                    </Col>
                  </Row>
                </Form.Item>
                // </Row>
              );
            })}
            {/* <Form.Item>
              <Button
                bgColor={'bg-white'}
                border={'border-neutral-90'}
                customClass={'no-show'}
                onClick={add}
              >
                <AddFillIcon />
              </Button>
            </Form.Item> */}
          </>
        )}
      </Form.List>
    </>
  );
}
